import React, { useEffect, useState } from 'react';
import { X, Loader2, AlertTriangle } from 'lucide-react'; 
import { formatPrice } from '../../utils/helpers';

// El script de Bancard se descarga recién acá, cuando se abre el pago (antes
// se cargaba en index.html en todas las páginas, y frenaba al resto de la
// app). Se espera hasta 15 segundos a que termine.
const BANCARD_SRC = 'https://vpos.infonet.com.py:8888/checkout/javascript/dist/bancard-checkout-4.0.0.js';
const cargarBancard = () => new Promise((resolve, reject) => {
  if (window.Bancard) return resolve(window.Bancard);
  let script = document.getElementById('bancard-checkout');
  if (!script) {
    script = document.createElement('script');
    script.id = 'bancard-checkout';
    script.async = true;
    script.src = BANCARD_SRC;
    document.head.appendChild(script);
  }
  const timer = setTimeout(() => reject(new Error('No se pudo cargar el sistema de pagos.')), 15000);
  const listo = () => {
    if (!window.Bancard) return;
    clearTimeout(timer);
    resolve(window.Bancard);
  };
  script.addEventListener('load', listo);
  script.addEventListener('error', () => { clearTimeout(timer); reject(new Error('No se pudo cargar el sistema de pagos.')); });
  // Por si ya terminó de cargar entre el chequeo de arriba y los listeners
  listo();
});

// ======================================================
// 💳 COMPONENTE BANCARD MODAL
// ======================================================
// 👇 AQUÍ ESTÁ EL ARREGLO: Agregamos companyId a la lista 👇
const BancardPaymentModal = ({ ticketId, total, companyId, onClose, onCancel, onPayLater, allowPayLater }) => {
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const styles = {
    "form-background-color": "#FFFFFF",
    "form-border-color": "#E5E7EB",
    "input-background-color": "#F3F4F6",
    "input-text-color": "#111827",
    "input-placeholder-color": "#9CA3AF",
    "input-border-color": "#D1D5DB",
    "button-background-color": "#F59E0B",
    "button-text-color": "#000000",
    "button-border-color": "#F59E0B",
    "label-text-color": "#374151",
    "text-color": "#374151"
  };

  useEffect(() => {
    const iniciarPago = async () => {
      try {
        const response = await fetch('https://reserva-barberia.netlify.app/.netlify/functions/bancard-auth', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            bookingId: ticketId,
            amount: total,
            description: `Reserva Barberia #${ticketId}`,
            companyId: companyId, // 👈 Ahora sí existe la variable
            returnPath: window.location.pathname // 👈 Enviamos la ruta dinámica
          })
        });

        if (!response.ok) throw new Error("Error de conexión con pagos.");
        const [data, Bancard] = await Promise.all([response.json(), cargarBancard()]);

        if (data.process_id && Bancard) {
            Bancard.Checkout.createForm('iframe-container', data.process_id, { styles });
            setLoading(false);
        } else {
            throw new Error("No se pudo iniciar el pago.");
        }
      } catch (e) {
        console.error(e);
        setErrorMsg(e.message);
        setLoading(false);
      }
    };
    iniciarPago();
    // eslint-disable-next-line
  }, [ticketId, total, companyId]);

  return (
   <div className="fixed inset-0 bg-black/80 z-[11000] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl border border-gray-200 flex flex-col max-h-[90vh]">
        
        <div className="bg-gray-50 p-4 flex justify-between items-center border-b border-gray-200 shrink-0">
          <div>
             <h3 className="text-xl font-bold text-gray-900">Pago Requerido</h3>
             <p className="text-xs text-gray-500">Ticket #{ticketId} • Total: <span className="font-bold text-green-600">{formatPrice(total)}</span></p>
          </div>
          
          <button 
            onClick={() => {
                if(window.confirm("⚠️ ¿Cancelar el pago? El turno quedará libre.")) {
                    onCancel(); 
                }
            }} 
            className="text-gray-400 hover:text-red-600 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="p-4 flex-1 overflow-y-auto min-h-[400px] relative bg-white">
          {loading && !errorMsg && (
            <div className="text-center text-gray-600 absolute inset-0 flex flex-col items-center justify-center bg-white z-10">
              <Loader2 className="w-12 h-12 animate-spin text-amber-500 mb-4" />
              <p className="animate-pulse">Cargando opciones de pago...</p>
            </div>
          )}

          {errorMsg && (
            <div className="text-center text-red-600 p-6 bg-red-50 rounded-xl border border-red-100 mx-4 mt-10">
                <AlertTriangle className="w-12 h-12 mx-auto mb-3"/>
                <p className="text-sm font-medium">{errorMsg}</p>
                <button onClick={onCancel} className="mt-4 text-sm underline text-gray-500">Cancelar y volver</button>
            </div>
          )}
          
          <div id="iframe-container" className="w-full h-full"></div>
        </div>
        
        {allowPayLater && (
            <div className="p-4 border-t border-gray-200 bg-gray-50">
                <button onClick={onPayLater} className="w-full py-3 text-gray-600 font-bold hover:bg-gray-200 rounded-lg transition-colors text-sm">
                    Pagar en el local (Efectivo/POS)
                </button>
            </div>
        )}
      </div>
    </div>
  );
};

export default BancardPaymentModal;